export const preferencesI18n = {
  en: {
    courses: 'Subjects',
    contentVisibility: 'Content visibility',
    visibilityDisclamer: 'If option "Allow students to see past and future subject content beyond the configured timeframe" is enabled for the subject, the students will be able to toggle between seeing all the subject content or just the relevant content in the configured timeframe by the teacher. By default: <b>{timeframe}</b> in the past and <b>{timeframe}</b> in the future.',
    days: 'Days',
    numberOfDays: 'Number of days',
    timeframe: 'Timeframe',
    timeframeDisclamer: 'This is the timeframe for the above configuration'
  },
  es: {
    courses: 'Cursos',
    contentVisibility: 'Visibilidad del contenido',
    visibilityDisclamer: 'Si la opción "Permita que los estudiantes vean el contenido del curso hacia pasado y futuro más allá del período de tiempo configurado" está habilitada para el curso, los estudiantes podrán alternar entre ver todo el contenido del curso o solo el contenido relevante en el período de tiempo configurado por el profesor. De forma predeterminada: <b>{timeframe}</b> en el pasado y <b>{timeframe}</b> en el futuro.',
    days: 'Días',
    numberOfDays: 'Número de días',
    timeframe: 'Período de tiempo',
    timeframeDisclamer: 'Este es el plazo para la configuración anterior.'
  }
}